import React, { useEffect, useState } from "react";
import { Alert, Button, Modal, Spin } from "antd";
import { DownloadOutlined, ExportOutlined } from "@ant-design/icons";
import { useExpenseWorkspaceStyle } from "../ExpenseWorkspace";
import '../expense-modals.css';

export const getExpenseDocumentKind = (contentType, fileName) => {
  const normalizedType = String(contentType || "").split(';')[0].trim().toLowerCase();
  const normalizedName = String(fileName || "").toLowerCase();
  if (normalizedType === "application/pdf") return "pdf";
  if (["image/jpeg", "image/png"].includes(normalizedType)) return "image";
  if (normalizedType) return "unsupported";
  if (normalizedName.endsWith(".pdf")) return "pdf";
  if (/\.(jpe?g|png)$/i.test(normalizedName)) return "image";
  return "unsupported";
};

export function ExpenseDocumentViewer({ loading = false, url, fileName = 'Pièce justificative', contentType = '' }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  const kind = getExpenseDocumentKind(contentType, fileName);
  return <div className="expense-document-viewer" aria-label={`Aperçu de ${fileName}`}>
    {loading ? <Spin tip="Chargement du justificatif…"><div style={{ minHeight: 80, minWidth: 160 }} /></Spin>
      : !url || failed ? <Alert type="info" showIcon message="Aperçu indisponible"
        description="Vous pouvez ouvrir ou télécharger le document avec les actions ci-dessus." />
      : kind === 'pdf' ? <iframe src={url} title={fileName} onError={() => setFailed(true)} />
      : kind === 'image' ? <img src={url} alt={fileName} onError={() => setFailed(true)} />
      : <Alert type="info" showIcon message="Aperçu non disponible pour ce format"
        description="Vous pouvez ouvrir ou télécharger le document." />}
  </div>;
}

export default function ExpenseDocumentPreviewModal({
  open,
  loading = false,
  url = null,
  fileName = "Pièce justificative",
  contentType = "",
  onClose,
}) {
  const style = useExpenseWorkspaceStyle();

  const downloadDocument = () => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "piece-justificative";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <Modal
      className="expense-modal expense-modal--preview"
      style={style}
      title={`Aperçu du justificatif — ${fileName || "Document"}`}
      open={open}
      onCancel={onClose}
      width={960}
      centered
      destroyOnClose
      footer={[
        <Button key="open" icon={<ExportOutlined />} href={url || undefined} target="_blank" rel="noopener noreferrer" disabled={!url || loading}>
          Ouvrir
        </Button>,
        <Button
          key="download"
          icon={<DownloadOutlined />}
          onClick={downloadDocument}
          disabled={!url || loading}
        >
          Télécharger
        </Button>,
        <Button key="close" type="primary" onClick={onClose}>
          Fermer
        </Button>,
      ]}
    >
      <ExpenseDocumentViewer loading={loading} url={url} fileName={fileName} contentType={contentType} />
    </Modal>
  );
}
